import { Box } from '@mui/material';
import { Button } from '../../../Button';
import { useMobileFixedEditActionStyles } from '../../../EditableSection';
import { useIsMobile } from '@uplift/hooks';

type ActionProps = {
  onClick: () => void;
  hidden?: boolean;
  text?: string;
};

export type InsuranceFixedEditActionProps = {
  primaryAction: ActionProps;
  secondaryAction: ActionProps;
};

export const InsuranceFixedEditAction: React.VFC<InsuranceFixedEditActionProps> = ({ primaryAction, secondaryAction }) => {
  const isMobile = useIsMobile('sm');
  const { classes: fixedActionClasses } = useMobileFixedEditActionStyles();

  if (!isMobile) return null;

  return (
    <Box className={fixedActionClasses.container}>
      {!primaryAction.hidden && (
        <Button
          variant="contained"
          color="secondary"
          size="large"
          fullWidth
          onClick={primaryAction.onClick}
        >
          {primaryAction.text ?? 'Edit Primary'}
        </Button>
      )}
      {!secondaryAction.hidden && (
        <Button
          variant="outlined"
          color="secondary"
          size="large"
          fullWidth
          onClick={secondaryAction.onClick}
        >
          {secondaryAction.text ?? 'Edit Secondary'}
        </Button>
      )}
    </Box>
  );
};
